import { call, put, takeLatest } from "redux-saga/effects";
import api from "../../../config/api";
import { compensationRequest, compensationRequestSuccess, compensationRequestFailure } from "../slice/compensationRequestSlice";
import { config } from "../../../config/global";
const COMPENSATION_REQUEST_URL = config.COMPENSATION_REQUEST;
const compensationRequestData = async payload => {
  const data = {
    mode: "no-cors",
    headers: {
      "Content-Type": "application/json"
    },
    loader: true,
    isGenericErr: true
  };
  const response = await api.post(COMPENSATION_REQUEST_URL, payload, data);
  return response;
};
function* getCompensationRequest(action) {
  try {
    const {
      payload
    } = action;
    const response = yield call(compensationRequestData, payload);
    yield put(compensationRequestSuccess(response.data));
  } catch (error) {
    yield put(compensationRequestFailure(error));
  }
}
export function* watchCompensationRequest() {
  yield takeLatest(compensationRequest.type, getCompensationRequest);
}